import { Button, Grid2 } from "@mui/material";
import { StepsEnum } from "./HorizontalLinearStepper";
import SNEvent from "./interfaces/SNEvent";
import { useRef, useState } from "react";
import { config } from "../../authConfig";
import useFetchMsal from "../../Common/UI/hooks/useFetchMsal";
import style from "./styles/CreateEvent.module.css";
import { LoadingIndicator } from "../../Common/UI/components/Loading";
import useIsAdminAndViewOnly from "../../Common/UI/hooks/useIsAdminAndViewOnly";

export default function NewStep({ event, handleStep, setEvent }: { event: SNEvent | null; handleStep: (stepNum: number) => void; setEvent: React.Dispatch<React.SetStateAction<SNEvent>> }) {
  // I can edit
  // I can save and it will move it to waiting for approval

  const execute = useFetchMsal();
  const [isSending, setSending] = useState<boolean>(false);
  const abortController = useRef<AbortController | null>(null);
  const { isAdmin } = useIsAdminAndViewOnly();

  const sendForApproval = async () => {
    try {
      abortController.current?.abort();
      abortController.current = new AbortController();

      setSending(true);
      const url = `${config.rootAPIUrl}${config.rootAPIList?.sendForApproval}`;
      const response = await execute("POST", url, event, abortController.current.signal);
      setEvent(response);
    } catch (error) {
      console.error(error);
      throw new Error("Event update failed!");
    } finally {
      setSending(false);
    }
  };

  return (
    <LoadingIndicator show={isSending}>
      {" "}
      <Grid2 container rowSpacing={2} justifyContent={"space-between"} alignItems={"center"} sx={{ paddingBottom: "20px" }}>
        <Grid2 size={2}>
          {isAdmin === false ? (
            <Button
              sx={{ maxWidth: "200px" }}
              id={style.createBtn}
              onClick={async () => {
                await sendForApproval();
                const step = StepsEnum.WaitingApproval;
                handleStep(step);
              }}
              variant="contained"
              disableElevation
              disabled={isSending}
            >
              {"Send for Approval"}
            </Button>
          ) : (
            <></>
          )}

          <Grid2 size={9}></Grid2>
          <Grid2 size={1}></Grid2>
        </Grid2>
      </Grid2>
    </LoadingIndicator>
  );
}
